import {MESSAGE_SET_ALERT} from '~/frontend/src/constants';
import {WebSocketFrontendMessageAlertMessage} from '~/shared/src/utilities/modules/webSocket';


export type SetAlertMessageAction = {
    type : typeof MESSAGE_SET_ALERT;
    message : WebSocketFrontendMessageAlertMessage[ 'parameters' ];
};

export function setAlertMessage( message : WebSocketFrontendMessageAlertMessage[ 'parameters' ] ) : SetAlertMessageAction {
    return {
        type: MESSAGE_SET_ALERT,
        message
    };
}

export type SetAlertMessage = typeof setAlertMessage;
